import React from "react";
import GrComponentFactory from "../../gr_component_factory";

export default GrComponentFactory.createClass({

  displayName: "SampleSlide",

  propTypes: {
    text: React.PropTypes.string,
  },

  render () {
    return (<div>{this.props.text}</div>);
  },

});
